import { Provider } from '@angular/core';
import { WIDGETS, type WidgetEntry } from './widgets.token';

/**
 * Provides the widget catalogue consumed by `WidgetComponent`. Call once at
 * the app root. See `libs/widget/README.md` for the recipe to add an entry.
 */
export function provideWidgets(): Provider {
    const entries: readonly WidgetEntry[] = [
        {
            key: 'automotive-exp3d',
            loader: () =>
                import('./widgets/automotive-exp3d/automotive-exp3d.component').then((m) => m.AutomotiveExp3dComponent),
        },
    ];

    return { provide: WIDGETS, useValue: entries };
}
